import { Box, InputBase, useTheme } from "@mui/material";
import { useEffect, useState } from "react";

import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import { useTranslation } from "react-i18next";
import { tokens } from "../../../theme";
import SHModal from "../../theme/Modal/SHModal";
import ButtonGroup from "../../theme/buttons/ButtonGroup";
import Shbutton from "../../theme/buttons/Shbutton";
import Subheading from "../../theme/text/Subheading";
import Text from "../../theme/text/Text";
import Barcode from "react-barcode";

const MEcheckTransferJob = (props) => {
    const {t} = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    let isStandAlone = false;
    if (window.matchMedia('(display-mode: standalone)').matches) {
        isStandAlone = true;
    }

    const handleClose = (reload) => {
        props.handleClose(reload);
    }

    return(
        <SHModal
            open={props.open}
            onClose={() => handleClose(false)}
        >
            <Box 
                sx={{
                    textAlign:"center",
                    paddingY:4,
                    paddingX:5,
                    display:"flex",
                    flexDirection:"column",
                    gap:1
                }}>
                <Subheading>{t("scan_barcode")}</Subheading>
            </Box>

            <Box
                sx={{
                    background:theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0],
                    padding:3,
                    pb:1,
                    borderTopLeftRadius:16,
                    borderTopRightRadius:16,
                    display:"flex",
                    flexDirection:"column",
                    gap:2
                }}
            >
                <Box
                    sx={{
                        overflow: 'hidden',
                        borderRadius: '12px',    
                        // display: 'inline-block',  
                        background:theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[100],
                        px:2,
                        py:3,
                        width:1,
                        display:"flex",
                        alignItems:'center',
                        justifyContent:'center',
                    }}
                >
                    <Barcode
                        value={props.barcode}
                        format="CODE128"
                        lineColor={colors.txt['primary']}
                        background="transparent"
                        width={3}
                        height={120}
                        displayValue
                        fontSize={14}
                        fontOptions="bold"
                        textAlign="center"
                    />
                </Box>
            </Box>
            <Box
                component="footer"
                sx={{
                    
                    display:"block",
                    width:1,
                    paddingBottom: isStandAlone ? "32px" : "16px",
                    display:"flex",
                    alignItems:"center",
                    paddingRight:3,
                    zIndex:1058,
                    position:"relative",
                    paddingTop:2,
                    background:`${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                    borderBottomLeftRadius:24,
                    borderBottomRightRadius:24,
                    justifyContent:"space-between",
                    "@media screen and (max-width: 47.9375em)" : {
                        paddingRight:0,
                    }
                }}
            >
                <Shbutton 
                    isCancel={true} 
                    className={"always-visible"} 
                    onClick={() => {
                        handleClose(false);
                    }} 
                    color="primary" 
                    variant="text" 
                    startIcon={<ArrowRightAltIcon/>}
                >
                    {t("cancel")}
                </Shbutton>
                <ButtonGroup version={2}>
                    <Shbutton className={"group-btn"} color={theme.palette.mode === "dark" ? "primaryGrey" : "grey"}
                    variant="contained" 
                    onClick={() => handleClose(true)}
                    >{t("transferred")}</Shbutton>
                </ButtonGroup>
            </Box>
        </SHModal>
    )
}

export default MEcheckTransferJob;
